import { useDecorator } from '../../utils/hooks';

const useProductDecorator = () => {
  return useDecorator<Product, DecoratedProduct>((product) => ({
    count: `x ${product.quantity}`,
  }));
};

export default useProductDecorator;
